// src/views/Facturacion/Clientes/FacturaClienteForm.jsx
import React, { useEffect, useState } from "react";
import BtnGuardar from "../../../components/buttons/BtnGuardar";
import BtnCancelar from "../../../components/buttons/BtnCancelar";
import ClienteAutocomplete from "../../../components/autocomplete/ClienteAutocomplete";
import LiquidacionSelect from "../../../components/select/LiquidacionSelect";
import { appFetchJson } from "../../../utils/http";
import apiRoutes from "../../../api/apiRoutes";


/**
 * Facturación por Cliente
 * Modal estándar FLPA
 */
export default function CrearFacturacionClientesPorLiquidacion({
  onClose = () => {},
  onSaved = () => {},
}) {
  // =========================
  // ESTADO
  // =========================
  const [cliente, setCliente] = useState(null);
  const [liquidacion, setLiquidacion] = useState(null);

  // =========================
  // ESC PARA CERRAR
  // =========================
  useEffect(() => {
    const esc = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", esc);
    return () => window.removeEventListener("keydown", esc);
  }, [onClose]);

  // =========================
  // VALIDACIÓN
  // =========================
  const isValid = !!cliente && !!liquidacion;

  // =========================
  // GUARDAR
  // =========================
  const handleGuardar = async () => {
  try {

    const payload = {
        clienteId: cliente.id,
        liquidacionId: liquidacion.id,

    };

    await appFetchJson(
        apiRoutes.facturaLiquidacionCliente.create(),
        {
            method: "POST",
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify(payload),
        },
        {
          showSuccess: true,
          successMessage: "Liquidacion creada al Cliente correctamente",
          onSuccessClose: () => onSaved(),
        }
    );

  } catch (e) {
    console.error(e);
  }
};


  // =========================
  // RENDER
  // =========================
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div
        className="modal-panel-lg"
        onClick={(e) => e.stopPropagation()}
      >
        {/* HEADER */}
        <div className="modal-header flex justify-between items-center">
          <h2 className="section-title">
            Introduzca los datos de Cliente por Factura
          </h2>
          <span className="text-sm text-red-600">
            (*) Campos obligatorios
          </span>
        </div>

        {/* BODY */}
        <div className="modal-body">
          <div className="border rounded-lg bg-white">
            <div className="px-6 py-6 space-y-4">

              {/* CLIENTE */}
              <FormRow label="Cliente:" required>
                <div className="max-w-md">
                  <ClienteAutocomplete
                    value={cliente}
                    onChange={setCliente}
                    placeholder="— Seleccione —"
                  />
                </div>
              </FormRow>

              {/* LIQUIDACIÓN */}
              <FormRow label="Liquidación:" required>
                <div className="max-w-md">
                  <LiquidacionSelect
                    value={liquidacion}
                    onChange={setLiquidacion}
                    autoLoad
                  />
                </div>
              </FormRow>

            </div>
          </div>
        </div>

        {/* FOOTER */}
        <div className="modal-footer">
          <div className="btn-row">
            <BtnGuardar
              label="Guardar"
              isValid={isValid}
              onClick={handleGuardar}
            />
            <BtnCancelar onClick={onClose} />
          </div>
        </div>
      </div>
    </div>
  );
}

/* =========================
   COMPONENTES AUX
========================= */

function FormRow({ label, required, children }) {
  return (
    <div className="grid grid-cols-[200px_1fr] items-center gap-3 max-w-3xl">
      <label className="text-right">
        {label}
        {required && (
          <span className="text-red-600 ml-1">*</span>
        )}
      </label>
      {children}
    </div>
  );
}
